import * as React from 'react';
import { ErrorBoundary } from '../../../../../../../ErrorBoundary';
import {
  TeamMemberFullName,
  TeamMemberPosition,
  TeamMemberProfilePicture,
} from './components';

export const TeamMemberContent = () => (
  <>
    <TeamMemberProfilePicture />
    <TeamMemberFullName />
    <ErrorBoundary renderNull>
      <TeamMemberPosition />
    </ErrorBoundary>
  </>
);
